import { Rule } from "antd/es/form";

/**
 * Cria uma regra de validação para campos de preenchimento obrigatório exibe uma mensagem de erro caso o campo não contenha nenhum valor
 *
 * @param message Mensagem de erro caso o campo não seja preenchido
 * @param rule Opções adicionais de validação
 */
export const required = (message: string, rule?: Partial<Rule>): Rule => ({
  required: true,
  message,
  ...rule,
});
